// extracted by mini-css-extract-plugin
export default {"unread-fav-chat-badge":"UnreadFavChatBadge_unread-fav-chat-badge__acG+J"};